var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("CardContainer", {
        attrs: {
          title: _vm.certification.title,
          subtitle: _vm.certification.institution,
        },
        on: { update: _vm.showModal, remove: _vm.removeCertification },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function () {
              return [
                _c("CardItem", {
                  attrs: { title: "Start Date", content: _vm.startDate },
                }),
                _c("CardItem", {
                  attrs: { title: "End Date", content: _vm.endDate },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm.isModalOpen
        ? _c("CertificationModal", {
            attrs: { userId: _vm.userId, certification: _vm.certification },
            on: {
              updated: function ($event) {
                return _vm.$emit("updated")
              },
            },
            model: {
              value: _vm.isModalOpen,
              callback: function ($$v) {
                _vm.isModalOpen = $$v
              },
              expression: "isModalOpen",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }